import React, { useState, useEffect } from 'react';
import '../styles/Loader.css';

function Loader({ onComplete }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let currentProgress = 0;
    const duration = 2000; // 2 seconds
    const targetProgress = 99;
    
    const intervals = [
      { from: 0, to: 15, pause: 150 },
      { from: 15, to: 35, pause: 100 },
      { from: 35, to: 58, pause: 200 },
      { from: 58, to: 78, pause: 120 },
      { from: 78, to: 99, pause: 80 },
    ];

    let intervalIndex = 0;
    let currentInterval = intervals[intervalIndex];
    
    const animate = () => {
      if (currentProgress >= targetProgress) {
        setProgress(99);
        setTimeout(() => {
          onComplete();
        }, 100);
        return;
      }

      currentProgress++;
      setProgress(currentProgress);

      // Check if we need to pause
      if (currentProgress === currentInterval.to && intervalIndex < intervals.length - 1) {
        intervalIndex++;
        setTimeout(() => {
          currentInterval = intervals[intervalIndex];
          requestAnimationFrame(animate);
        }, currentInterval.pause);
      } else {
        setTimeout(animate, duration / targetProgress);
      }
    };

    animate();
  }, [onComplete]);

  return (
    <div className="loader-container">
      <div className="loader-content">
        <div className="loader-progress-wrapper">
          <div className="loader-progress-bar">
            <div 
              className="loader-progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
        <div className="loader-percentage">
          {progress.toString().padStart(2, '0')}%
        </div>
      </div>
    </div>
  );
}

export default Loader;
